<template>
  <!-- <ComponentDropdown></ComponentDropdown> -->
  <div class="zj-search-result-table">
    <el-table :data="tableData" @row-click="rowclick" :show-header="false">
      <el-table-column>
        <template slot-scope="scope">
          <ComponentInfoPanel
            type="MaterialStorage"
            v-bind:info="convert(scope.$index,scope.row)"
            v-bind:isMaterial="true"
          ></ComponentInfoPanel>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      background
      :total="total"
    ></el-pagination>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import MyApis from "../../../../apis";
import ComponentInfoPanel from "./Component-InfoPanel";
import { warehouseList } from "@/api/src/emergency_warehouse";

export default {
  name: "ZjComponent-MaterialStorage",
  components: {
    ComponentInfoPanel: ComponentInfoPanel
  },
  props: {
    targetUri: Object,
    center: {
      type: Object,
      default: function() {
        return [0, 0];
      }
    },
    searchText: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      selectData: null
    };
  },
  mounted: function() {
    this.search();
  },
  methods: {
    convert(index, row) {
      var result = {
        index:(this.pageSize *(this.currentPage - 1)) + index + 1,
        ...row,
      };
      return result;
    },
    search() {
      let searchInfo = {
        name: this.searchText,
        size: this.pageSize,
        current: this.currentPage,
        longitude: this.center[0] || 0,
        latitude: this.center[1] || 0,
      };
      warehouseList(searchInfo)
        .then(r => {
          r = r.data;
          this.tableData = r.records;
          this.total = r.total;
        })
        .catch(e => {
          console.log(e);
        });
    },
    // eslint-disable-next-line no-unused-vars
    rowclick(row, column, e) {
      this.dispatch("ZjEmergencyOneMap", "poiselected", row.id);
      this.dispatch("ZjEmergencyOperations", "poiselected", row.id);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    }
  },
  watch: {
    center: function() {
      this.search();
    },
    searchText: function() {
      this.search();
    }
  }
};
</script>